import { cloneDeep } from 'lodash';

const cancelCall = (state, payload) => {
  try {
    const { placeId, pointId, userId } = payload;
    const newState = cloneDeep(state);
    const pointCalls = newState.calls[pointId]
      ? newState.calls[pointId].filter((call) => call.userId !== userId)
      : [];
    if (pointCalls.length > 0) {
      newState.calls[pointId] = pointCalls;
    } else {
      if (newState.calls[pointId]) {
        delete newState.calls[pointId];
      }
    }
    return newState;
  } catch (error) {
    console.log('ERROR FROM cancelCall', error);
    return state;
  }
};

export { cancelCall };
